import { gql } from "@apollo/client"

export const ADD_BULK_APPROVE_TRADE_PROFILE = gql`
  mutation AddBulkApproveTradeProfile($input: BulkApproveTradeProfilesInput!) {
    addBulkApproveTradeProfile(input: $input) {
      ok
      error
    }
  }
`

export const CREATE_UPDATE_SALES_ORDER = gql`
  mutation CreateUpdateSalesOrder($input: ShipmentPlanInput!) {
    createUpdateShipmentPlan(input: $input) {
      success
      message
    }
  }
`
